import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import { useDebugDialogStore } from '@/store/debug-dialog-store'


export default /*@__PURE__*/_defineComponent({
  __name: 'DebugDialog',
  setup(__props) {

const debugDialogStore = useDebugDialogStore()
const { isOpen, debugData } = storeToRefs(debugDialogStore)

const formatted = computed(() => (debugData.value?.data ? JSON.stringify(debugData.value.data, null, 2) : ''))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalContainer, {
    isOpened: _unref(isOpen),
    title: _unref(debugData)?.title,
    wide: true,
    "data-interface-section": "debug-dialog",
    onCloseModal: _unref(debugDialogStore).closeDebugDialog
  }, {
    "custom-content": _withCtx(() => [
      _createElementVNode("pre", {
        class: _normalizeClass(_ctx.$style.body)
      }, _toDisplayString(formatted.value), 3)
    ]),
    _: 1
  }, 8, ["isOpened", "title", "onCloseModal"]))
}
}

})